// Lista de países com códigos DDI e bandeiras
export interface Country {
  code: string; // ISO 3166-1 alpha-2 (ex: 'BR')
  name: string; // Nome do país
  dialCode: string; // Código DDI (ex: '+55')
  flag: string; // Emoji da bandeira
}

export const countries: Country[] = [
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colômbia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'EC', name: 'Equador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'BO', name: 'Bolívia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'PY', name: 'Paraguai', dialCode: '+595', flag: '🇵🇾' },
  { code: 'UY', name: 'Uruguai', dialCode: '+598', flag: '🇺🇾' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'ES', name: 'Espanha', dialCode: '+34', flag: '🇪🇸' },
  { code: 'FR', name: 'França', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemanha', dialCode: '+49', flag: '🇩🇪' },
  { code: 'IT', name: 'Itália', dialCode: '+39', flag: '🇮🇹' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'NL', name: 'Holanda', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', name: 'Suíça', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', name: 'Áustria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', name: 'Suécia', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlândia', dialCode: '+358', flag: '🇫🇮' },
  { code: 'PL', name: 'Polônia', dialCode: '+48', flag: '🇵🇱' },
  { code: 'CZ', name: 'República Tcheca', dialCode: '+420', flag: '🇨🇿' },
  { code: 'GR', name: 'Grécia', dialCode: '+30', flag: '🇬🇷' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353', flag: '🇮🇪' },
  { code: 'RU', name: 'Rússia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Japão', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Coreia do Sul', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'Índia', dialCode: '+91', flag: '🇮🇳' },
  { code: 'AU', name: 'Austrália', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nova Zelândia', dialCode: '+64', flag: '🇳🇿' },
  { code: 'ZA', name: 'África do Sul', dialCode: '+27', flag: '🇿🇦' },
  { code: 'EG', name: 'Egito', dialCode: '+20', flag: '🇪🇬' },
  { code: 'NG', name: 'Nigéria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'KE', name: 'Quênia', dialCode: '+254', flag: '🇰🇪' },
  { code: 'AE', name: 'Emirados Árabes Unidos', dialCode: '+971', flag: '🇦🇪' },
  { code: 'SA', name: 'Arábia Saudita', dialCode: '+966', flag: '🇸🇦' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'TR', name: 'Turquia', dialCode: '+90', flag: '🇹🇷' },
  { code: 'TH', name: 'Tailândia', dialCode: '+66', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietnã', dialCode: '+84', flag: '🇻🇳' },
  { code: 'PH', name: 'Filipinas', dialCode: '+63', flag: '🇵🇭' },
  { code: 'ID', name: 'Indonésia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'MY', name: 'Malásia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapura', dialCode: '+65', flag: '🇸🇬' },
  { code: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰' },
  { code: 'TW', name: 'Taiwan', dialCode: '+886', flag: '🇹🇼' },
  { code: 'MO', name: 'Macau', dialCode: '+853', flag: '🇲🇴' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'PK', name: 'Paquistão', dialCode: '+92', flag: '🇵🇰' },
  { code: 'AF', name: 'Afeganistão', dialCode: '+93', flag: '🇦🇫' },
  { code: 'IR', name: 'Irã', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraque', dialCode: '+964', flag: '🇮🇶' },
  { code: 'JO', name: 'Jordânia', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', name: 'Líbano', dialCode: '+961', flag: '🇱🇧' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'QA', name: 'Catar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'BH', name: 'Bahrein', dialCode: '+973', flag: '🇧🇭' },
  { code: 'OM', name: 'Omã', dialCode: '+968', flag: '🇴🇲' },
  { code: 'YE', name: 'Iêmen', dialCode: '+967', flag: '🇾🇪' },
  { code: 'SY', name: 'Síria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'PS', name: 'Palestina', dialCode: '+970', flag: '🇵🇸' },
  { code: 'CY', name: 'Chipre', dialCode: '+357', flag: '🇨🇾' },
  { code: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  { code: 'IS', name: 'Islândia', dialCode: '+354', flag: '🇮🇸' },
  { code: 'LU', name: 'Luxemburgo', dialCode: '+352', flag: '🇱🇺' },
  { code: 'LI', name: 'Liechtenstein', dialCode: '+423', flag: '🇱🇮' },
  { code: 'MC', name: 'Mônaco', dialCode: '+377', flag: '🇲🇨' },
  { code: 'AD', name: 'Andorra', dialCode: '+376', flag: '🇦🇩' },
  { code: 'SM', name: 'San Marino', dialCode: '+378', flag: '🇸🇲' },
  { code: 'VA', name: 'Vaticano', dialCode: '+39', flag: '🇻🇦' },
  { code: 'RO', name: 'Romênia', dialCode: '+40', flag: '🇷🇴' },
  { code: 'HU', name: 'Hungria', dialCode: '+36', flag: '🇭🇺' },
  { code: 'BG', name: 'Bulgária', dialCode: '+359', flag: '🇧🇬' },
  { code: 'HR', name: 'Croácia', dialCode: '+385', flag: '🇭🇷' },
  { code: 'SI', name: 'Eslovênia', dialCode: '+386', flag: '🇸🇮' },
  { code: 'SK', name: 'Eslováquia', dialCode: '+421', flag: '🇸🇰' },
  { code: 'EE', name: 'Estônia', dialCode: '+372', flag: '🇪🇪' },
  { code: 'LV', name: 'Letônia', dialCode: '+371', flag: '🇱🇻' },
  { code: 'LT', name: 'Lituânia', dialCode: '+370', flag: '🇱🇹' },
  { code: 'BY', name: 'Bielorrússia', dialCode: '+375', flag: '🇧🇾' },
  { code: 'UA', name: 'Ucrânia', dialCode: '+380', flag: '🇺🇦' },
  { code: 'MD', name: 'Moldávia', dialCode: '+373', flag: '🇲🇩' },
  { code: 'RS', name: 'Sérvia', dialCode: '+381', flag: '🇷🇸' },
  { code: 'ME', name: 'Montenegro', dialCode: '+382', flag: '🇲🇪' },
  { code: 'BA', name: 'Bósnia e Herzegovina', dialCode: '+387', flag: '🇧🇦' },
  { code: 'MK', name: 'Macedônia do Norte', dialCode: '+389', flag: '🇲🇰' },
  { code: 'AL', name: 'Albânia', dialCode: '+355', flag: '🇦🇱' },
  { code: 'XK', name: 'Kosovo', dialCode: '+383', flag: '🇽🇰' },
  { code: 'TN', name: 'Tunísia', dialCode: '+216', flag: '🇹🇳' },
  { code: 'DZ', name: 'Argélia', dialCode: '+213', flag: '🇩🇿' },
  { code: 'MA', name: 'Marrocos', dialCode: '+212', flag: '🇲🇦' },
  { code: 'LY', name: 'Líbia', dialCode: '+218', flag: '🇱🇾' },
  { code: 'SD', name: 'Sudão', dialCode: '+249', flag: '🇸🇩' },
  { code: 'ET', name: 'Etiópia', dialCode: '+251', flag: '🇪🇹' },
  { code: 'UG', name: 'Uganda', dialCode: '+256', flag: '🇺🇬' },
  { code: 'TZ', name: 'Tanzânia', dialCode: '+255', flag: '🇹🇿' },
  { code: 'RW', name: 'Ruanda', dialCode: '+250', flag: '🇷🇼' },
  { code: 'GH', name: 'Gana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'CI', name: 'Costa do Marfim', dialCode: '+225', flag: '🇨🇮' },
  { code: 'SN', name: 'Senegal', dialCode: '+221', flag: '🇸🇳' },
  { code: 'CM', name: 'Camarões', dialCode: '+237', flag: '🇨🇲' },
  { code: 'CD', name: 'República Democrática do Congo', dialCode: '+243', flag: '🇨🇩' },
  { code: 'AO', name: 'Angola', dialCode: '+244', flag: '🇦🇴' },
  { code: 'MZ', name: 'Moçambique', dialCode: '+258', flag: '🇲🇿' },
  { code: 'ZM', name: 'Zâmbia', dialCode: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbábue', dialCode: '+263', flag: '🇿🇼' },
  { code: 'BW', name: 'Botsuana', dialCode: '+267', flag: '🇧🇼' },
  { code: 'NA', name: 'Namíbia', dialCode: '+264', flag: '🇳🇦' },
  { code: 'MG', name: 'Madagascar', dialCode: '+261', flag: '🇲🇬' },
  { code: 'MU', name: 'Maurício', dialCode: '+230', flag: '🇲🇺' },
  { code: 'SC', name: 'Seicheles', dialCode: '+248', flag: '🇸🇨' },
  { code: 'MV', name: 'Maldivas', dialCode: '+960', flag: '🇲🇻' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'KH', name: 'Camboja', dialCode: '+855', flag: '🇰🇭' },
  { code: 'BN', name: 'Brunei', dialCode: '+673', flag: '🇧🇳' },
  { code: 'TL', name: 'Timor-Leste', dialCode: '+670', flag: '🇹🇱' },
  { code: 'PG', name: 'Papua Nova Guiné', dialCode: '+675', flag: '🇵🇬' },
  { code: 'FJ', name: 'Fiji', dialCode: '+679', flag: '🇫🇯' },
  { code: 'NC', name: 'Nova Caledônia', dialCode: '+687', flag: '🇳🇨' },
  { code: 'PF', name: 'Polinésia Francesa', dialCode: '+689', flag: '🇵🇫' },
  { code: 'GU', name: 'Guam', dialCode: '+1', flag: '🇬🇺' },
  { code: 'AS', name: 'Samoa Americana', dialCode: '+1', flag: '🇦🇸' },
  { code: 'MP', name: 'Ilhas Marianas do Norte', dialCode: '+1', flag: '🇲🇵' },
  { code: 'VI', name: 'Ilhas Virgens Americanas', dialCode: '+1', flag: '🇻🇮' },
  { code: 'PR', name: 'Porto Rico', dialCode: '+1', flag: '🇵🇷' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1', flag: '🇩🇴' },
  { code: 'JM', name: 'Jamaica', dialCode: '+1', flag: '🇯🇲' },
  { code: 'TT', name: 'Trinidad e Tobago', dialCode: '+1', flag: '🇹🇹' },
  { code: 'BB', name: 'Barbados', dialCode: '+1', flag: '🇧🇧' },
  { code: 'BS', name: 'Bahamas', dialCode: '+1', flag: '🇧🇸' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { code: 'HT', name: 'Haiti', dialCode: '+509', flag: '🇭🇹' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'BZ', name: 'Belize', dialCode: '+501', flag: '🇧🇿' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'NI', name: 'Nicarágua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'PA', name: 'Panamá', dialCode: '+507', flag: '🇵🇦' },
  { code: 'GY', name: 'Guiana', dialCode: '+592', flag: '🇬🇾' },
  { code: 'SR', name: 'Suriname', dialCode: '+597', flag: '🇸🇷' },
  { code: 'GF', name: 'Guiana Francesa', dialCode: '+594', flag: '🇬🇫' },
  { code: 'FK', name: 'Ilhas Malvinas', dialCode: '+500', flag: '🇫🇰' },
  { code: 'GS', name: 'Geórgia do Sul e Ilhas Sandwich do Sul', dialCode: '+500', flag: '🇬🇸' },
  { code: 'AI', name: 'Anguilla', dialCode: '+1', flag: '🇦🇮' },
  { code: 'AG', name: 'Antígua e Barbuda', dialCode: '+1', flag: '🇦🇬' },
  { code: 'VG', name: 'Ilhas Virgens Britânicas', dialCode: '+1', flag: '🇻🇬' },
  { code: 'KY', name: 'Ilhas Cayman', dialCode: '+1', flag: '🇰🇾' },
  { code: 'TC', name: 'Ilhas Turks e Caicos', dialCode: '+1', flag: '🇹🇨' },
  { code: 'MS', name: 'Montserrat', dialCode: '+1', flag: '🇲🇸' },
  { code: 'DM', name: 'Dominica', dialCode: '+1', flag: '🇩🇲' },
  { code: 'GD', name: 'Granada', dialCode: '+1', flag: '🇬🇩' },
  { code: 'LC', name: 'Santa Lúcia', dialCode: '+1', flag: '🇱🇨' },
  { code: 'VC', name: 'São Vicente e Granadinas', dialCode: '+1', flag: '🇻🇨' },
  { code: 'KN', name: 'São Cristóvão e Nevis', dialCode: '+1', flag: '🇰🇳' },
  { code: 'AW', name: 'Aruba', dialCode: '+297', flag: '🇦🇼' },
  { code: 'CW', name: 'Curaçao', dialCode: '+599', flag: '🇨🇼' },
  { code: 'SX', name: 'São Martinho (Países Baixos)', dialCode: '+1', flag: '🇸🇽' },
  { code: 'BQ', name: 'Caribe Holandês', dialCode: '+599', flag: '🇧🇶' },
  { code: 'GP', name: 'Guadalupe', dialCode: '+590', flag: '🇬🇵' },
  { code: 'MQ', name: 'Martinica', dialCode: '+596', flag: '🇲🇶' },
  { code: 'BL', name: 'São Bartolomeu', dialCode: '+590', flag: '🇧🇱' },
  { code: 'MF', name: 'São Martinho (França)', dialCode: '+590', flag: '🇲🇫' },
  { code: 'PM', name: 'São Pedro e Miquelão', dialCode: '+508', flag: '🇵🇲' },
  { code: 'WF', name: 'Wallis e Futuna', dialCode: '+681', flag: '🇼🇫' },
  { code: 'TO', name: 'Tonga', dialCode: '+676', flag: '🇹🇴' },
  { code: 'WS', name: 'Samoa', dialCode: '+685', flag: '🇼🇸' },
  { code: 'TV', name: 'Tuvalu', dialCode: '+688', flag: '🇹🇻' },
  { code: 'KI', name: 'Quiribati', dialCode: '+686', flag: '🇰🇮' },
  { code: 'NR', name: 'Nauru', dialCode: '+674', flag: '🇳🇷' },
  { code: 'PW', name: 'Palau', dialCode: '+680', flag: '🇵🇼' },
  { code: 'FM', name: 'Micronésia', dialCode: '+691', flag: '🇫🇲' },
  { code: 'MH', name: 'Ilhas Marshall', dialCode: '+692', flag: '🇲🇭' },
  { code: 'SB', name: 'Ilhas Salomão', dialCode: '+677', flag: '🇸🇧' },
  { code: 'VU', name: 'Vanuatu', dialCode: '+678', flag: '🇻🇺' },
  { code: 'CK', name: 'Ilhas Cook', dialCode: '+682', flag: '🇨🇰' },
  { code: 'NU', name: 'Niue', dialCode: '+683', flag: '🇳🇺' },
  { code: 'TK', name: 'Tokelau', dialCode: '+690', flag: '🇹🇰' },
  { code: 'PN', name: 'Ilhas Pitcairn', dialCode: '+872', flag: '🇵🇳' },
  { code: 'SH', name: 'Santa Helena', dialCode: '+290', flag: '🇸🇭' },
  { code: 'ST', name: 'São Tomé e Príncipe', dialCode: '+239', flag: '🇸🇹' },
  { code: 'CV', name: 'Cabo Verde', dialCode: '+238', flag: '🇨🇻' },
  { code: 'GW', name: 'Guiné-Bissau', dialCode: '+245', flag: '🇬🇼' },
  { code: 'GN', name: 'Guiné', dialCode: '+224', flag: '🇬🇳' },
  { code: 'SL', name: 'Serra Leoa', dialCode: '+232', flag: '🇸🇱' },
  { code: 'LR', name: 'Libéria', dialCode: '+231', flag: '🇱🇷' },
  { code: 'TG', name: 'Togo', dialCode: '+228', flag: '🇹🇬' },
  { code: 'BJ', name: 'Benin', dialCode: '+229', flag: '🇧🇯' },
  { code: 'BF', name: 'Burkina Faso', dialCode: '+226', flag: '🇧🇫' },
  { code: 'ML', name: 'Mali', dialCode: '+223', flag: '🇲🇱' },
  { code: 'NE', name: 'Níger', dialCode: '+227', flag: '🇳🇪' },
  { code: 'TD', name: 'Chade', dialCode: '+235', flag: '🇹🇩' },
  { code: 'CF', name: 'República Centro-Africana', dialCode: '+236', flag: '🇨🇫' },
  { code: 'GA', name: 'Gabão', dialCode: '+241', flag: '🇬🇦' },
  { code: 'CG', name: 'República do Congo', dialCode: '+242', flag: '🇨🇬' },
  { code: 'GQ', name: 'Guiné Equatorial', dialCode: '+240', flag: '🇬🇶' },
  { code: 'ST', name: 'São Tomé e Príncipe', dialCode: '+239', flag: '🇸🇹' },
  { code: 'KM', name: 'Comores', dialCode: '+269', flag: '🇰🇲' },
  { code: 'DJ', name: 'Djibuti', dialCode: '+253', flag: '🇩🇯' },
  { code: 'ER', name: 'Eritreia', dialCode: '+291', flag: '🇪🇷' },
  { code: 'SO', name: 'Somália', dialCode: '+252', flag: '🇸🇴' },
  { code: 'SS', name: 'Sudão do Sul', dialCode: '+211', flag: '🇸🇸' },
  { code: 'CF', name: 'República Centro-Africana', dialCode: '+236', flag: '🇨🇫' },
  { code: 'CM', name: 'Camarões', dialCode: '+237', flag: '🇨🇲' },
  { code: 'TD', name: 'Chade', dialCode: '+235', flag: '🇹🇩' },
  { code: 'NE', name: 'Níger', dialCode: '+227', flag: '🇳🇪' },
  { code: 'ML', name: 'Mali', dialCode: '+223', flag: '🇲🇱' },
  { code: 'MR', name: 'Mauritânia', dialCode: '+222', flag: '🇲🇷' },
  { code: 'SN', name: 'Senegal', dialCode: '+221', flag: '🇸🇳' },
  { code: 'GM', name: 'Gâmbia', dialCode: '+220', flag: '🇬🇲' },
  { code: 'GW', name: 'Guiné-Bissau', dialCode: '+245', flag: '🇬🇼' },
  { code: 'GN', name: 'Guiné', dialCode: '+224', flag: '🇬🇳' },
  { code: 'SL', name: 'Serra Leoa', dialCode: '+232', flag: '🇸🇱' },
  { code: 'LR', name: 'Libéria', dialCode: '+231', flag: '🇱🇷' },
  { code: 'CI', name: 'Costa do Marfim', dialCode: '+225', flag: '🇨🇮' },
  { code: 'GH', name: 'Gana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'TG', name: 'Togo', dialCode: '+228', flag: '🇹🇬' },
  { code: 'BJ', name: 'Benin', dialCode: '+229', flag: '🇧🇯' },
  { code: 'BF', name: 'Burkina Faso', dialCode: '+226', flag: '🇧🇫' },
  { code: 'UZ', name: 'Uzbequistão', dialCode: '+998', flag: '🇺🇿' },
  { code: 'KZ', name: 'Cazaquistão', dialCode: '+7', flag: '🇰🇿' },
  { code: 'KG', name: 'Quirguistão', dialCode: '+996', flag: '🇰🇬' },
  { code: 'TJ', name: 'Tajiquistão', dialCode: '+992', flag: '🇹🇯' },
  { code: 'TM', name: 'Turcomenistão', dialCode: '+993', flag: '🇲🇾' },
  { code: 'AZ', name: 'Azerbaijão', dialCode: '+994', flag: '🇦🇿' },
  { code: 'AM', name: 'Armênia', dialCode: '+374', flag: '🇦🇲' },
  { code: 'GE', name: 'Geórgia', dialCode: '+995', flag: '🇬🇪' },
  { code: 'MN', name: 'Mongólia', dialCode: '+976', flag: '🇲🇳' },
  { code: 'KP', name: 'Coreia do Norte', dialCode: '+850', flag: '🇰🇵' },
  { code: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { code: 'BT', name: 'Butão', dialCode: '+975', flag: '🇧🇹' },
  { code: 'MV', name: 'Maldivas', dialCode: '+960', flag: '🇲🇻' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'PK', name: 'Paquistão', dialCode: '+92', flag: '🇵🇰' },
  { code: 'AF', name: 'Afeganistão', dialCode: '+93', flag: '🇦🇫' },
  { code: 'IR', name: 'Irã', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraque', dialCode: '+964', flag: '🇮🇶' },
  { code: 'JO', name: 'Jordânia', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', name: 'Líbano', dialCode: '+961', flag: '🇱🇧' },
  { code: 'SY', name: 'Síria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'PS', name: 'Palestina', dialCode: '+970', flag: '🇵🇸' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'CY', name: 'Chipre', dialCode: '+357', flag: '🇨🇾' },
  { code: 'TR', name: 'Turquia', dialCode: '+90', flag: '🇹🇷' },
  { code: 'GR', name: 'Grécia', dialCode: '+30', flag: '🇬🇷' },
  { code: 'BG', name: 'Bulgária', dialCode: '+359', flag: '🇧🇬' },
  { code: 'RO', name: 'Romênia', dialCode: '+40', flag: '🇷🇴' },
  { code: 'MD', name: 'Moldávia', dialCode: '+373', flag: '🇲🇩' },
  { code: 'UA', name: 'Ucrânia', dialCode: '+380', flag: '🇺🇦' },
  { code: 'BY', name: 'Bielorrússia', dialCode: '+375', flag: '🇧🇾' },
  { code: 'LT', name: 'Lituânia', dialCode: '+370', flag: '🇱🇹' },
  { code: 'LV', name: 'Letônia', dialCode: '+371', flag: '🇱🇻' },
  { code: 'EE', name: 'Estônia', dialCode: '+372', flag: '🇪🇪' },
  { code: 'FI', name: 'Finlândia', dialCode: '+358', flag: '🇫🇮' },
  { code: 'SE', name: 'Suécia', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰' },
  { code: 'IS', name: 'Islândia', dialCode: '+354', flag: '🇮🇸' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353', flag: '🇮🇪' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'FR', name: 'França', dialCode: '+33', flag: '🇫🇷' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪' },
  { code: 'NL', name: 'Holanda', dialCode: '+31', flag: '🇳🇱' },
  { code: 'DE', name: 'Alemanha', dialCode: '+49', flag: '🇩🇪' },
  { code: 'CH', name: 'Suíça', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', name: 'Áustria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'IT', name: 'Itália', dialCode: '+39', flag: '🇮🇹' },
  { code: 'ES', name: 'Espanha', dialCode: '+34', flag: '🇪🇸' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'LU', name: 'Luxemburgo', dialCode: '+352', flag: '🇱🇺' },
  { code: 'LI', name: 'Liechtenstein', dialCode: '+423', flag: '🇱🇮' },
  { code: 'MC', name: 'Mônaco', dialCode: '+377', flag: '🇲🇨' },
  { code: 'AD', name: 'Andorra', dialCode: '+376', flag: '🇦🇩' },
  { code: 'SM', name: 'San Marino', dialCode: '+378', flag: '🇸🇲' },
  { code: 'VA', name: 'Vaticano', dialCode: '+39', flag: '🇻🇦' },
  { code: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  { code: 'HR', name: 'Croácia', dialCode: '+385', flag: '🇭🇷' },
  { code: 'SI', name: 'Eslovênia', dialCode: '+386', flag: '🇸🇮' },
  { code: 'SK', name: 'Eslováquia', dialCode: '+421', flag: '🇸🇰' },
  { code: 'CZ', name: 'República Tcheca', dialCode: '+420', flag: '🇨🇿' },
  { code: 'PL', name: 'Polônia', dialCode: '+48', flag: '🇵🇱' },
  { code: 'HU', name: 'Hungria', dialCode: '+36', flag: '🇭🇺' },
  { code: 'RS', name: 'Sérvia', dialCode: '+381', flag: '🇷🇸' },
  { code: 'ME', name: 'Montenegro', dialCode: '+382', flag: '🇲🇪' },
  { code: 'BA', name: 'Bósnia e Herzegovina', dialCode: '+387', flag: '🇧🇦' },
  { code: 'MK', name: 'Macedônia do Norte', dialCode: '+389', flag: '🇲🇰' },
  { code: 'AL', name: 'Albânia', dialCode: '+355', flag: '🇦🇱' },
  { code: 'XK', name: 'Kosovo', dialCode: '+383', flag: '🇽🇰' },
];

// Função para buscar país por código DDI
export function getCountryByDialCode(dialCode: string): Country | undefined {
  return countries.find(country => country.dialCode === dialCode);
}

// Função para buscar país por código ISO
export function getCountryByCode(code: string): Country | undefined {
  return countries.find(country => country.code.toLowerCase() === code.toLowerCase());
}

// Mapeamento de aliases comuns para códigos ISO
const countryAliases: Record<string, string> = {
  'uea': 'AE', // Emirados Árabes Unidos
  'uae': 'AE', // United Arab Emirates
  'eua': 'US', // Estados Unidos da América
  'usa': 'US',
  'reino unido': 'GB',
  'uk': 'GB',
  'inglaterra': 'GB',
};

// Função para filtrar países por busca
// Função para remover acentos
const normalizeString = (str: string) =>
  str
    .toLowerCase()
    .normalize('NFD') // Separa acentos das letras
    .replace(/[\u0300-\u036f]/g, ''); // Remove os acentos

// Função para filtrar países por busca
export function searchCountries(query: string): Country[] {
  if (!query || query.trim() === '') {
    return countries;
  }

  const trimmedQuery = query.trim();
  
  // Normaliza a query (sem acento, minúscula)
  const lowerQuery = normalizeString(trimmedQuery);

  // A query original (para DDIs) e em maiúscula (para Códigos)
  const upperQuery = trimmedQuery.toUpperCase();

  // Verificar se há um alias conhecido (usa a query normalizada)
  const aliasCode = countryAliases[lowerQuery];

  return countries.filter(country => {
    // Buscar por nome do país (normalizado)
    const nameMatch = normalizeString(country.name).includes(lowerQuery);

    // Buscar por código DDI (ex: +55, +1, etc) - não precisa normalizar
    const dialCodeMatch =
      country.dialCode.includes(trimmedQuery) ||
      country.dialCode.replace('+', '').includes(trimmedQuery);

    // Buscar por código ISO (ex: BR, US) - não precisa normalizar
    const codeMatch = country.code.toUpperCase().includes(upperQuery);

    // Buscar por alias (ex: eua -> US)
    const aliasMatch = aliasCode && country.code === aliasCode;

    return nameMatch || dialCodeMatch || codeMatch || aliasMatch;
  });
}
